import { Squadre } from './squadre';

export class Match {
    public id: number = null;
    public descrizione: string = null;
    public team1: Squadre = null;
    public team2: Squadre = null;
    public dataMatch: string = null;

    constructor(){
        this.team1 = new Squadre();
        this.team2 = new Squadre();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/match.ts